import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { formatWithHardcodedCurrency } from "components/common/FormattedComponents";
import messages from "components/messagesDescription";
import BenefitCheckoutLegacyTable from "./BenefitCheckoutLegacyTable";
import BenefitCheckoutResponsiveTable from "./BenefitCheckoutResponsiveTable";

const BenefitCheckoutItems = ({
  currency,
  benefits: { all = [], byId },
  isNarrowScreen = false,
  intl,
  //derived props
  items = all
    .map(id => byId[id])
    .map(
      (
        {
          total,
          total: {
            description: {
              otherValue: descriptionOtherValue,
              core: { value: coreValue } = {},
              option: { value: optionValue } = {},
            },
            requiresUW,
            label: { otherValue },
          } = {},
          guaranteed,
          subjectToUW,
          type,
          ...item
        },
        index
      ) => ({
        ...item,
        total,
        uWFormID: requiresUW && total.uWFormID,
        showUWSumAssured: type === "SumAssuredBased" && requiresUW,
        // showUWPlanBased = type === "PlanBased" && requiresUW,
        planNameMessageDescription: {
          id: otherValue,
          defaultMessage: otherValue,
        },
        displayValue: descriptionOtherValue
          ? descriptionOtherValue
          : coreValue
            ? formatWithHardcodedCurrency(coreValue)
            : optionValue
              ? formatWithHardcodedCurrency(optionValue)
              : null,
        rowClassName: `apl-data-table__row--${index % 2 === 0 ? "odd" : "even"}`,
      })
    ),
  subTotal = items.reduce(
    (prev, { total: { price: { numericValue = 0 } = {} } = {} }) => prev + numericValue,
    0
  ),
}) => {
  return (
    !!all.length && (
      <article className="card">
        <header>
          <h3>
            <FormattedMessage {...messages.riskAndMedicalDescription} />
          </h3>
        </header>
        <section>
          {isNarrowScreen ? (
            <BenefitCheckoutResponsiveTable
              intl={intl}
              items={items}
              subTotal={subTotal}
              currency={currency}
            />
          ) : (
            <BenefitCheckoutLegacyTable items={items} subTotal={subTotal} currency={currency} />
          )}
        </section>
      </article>
    )
  );
};

BenefitCheckoutItems.propTypes = {
  benefits: PropTypes.object,
  items: PropTypes.array,
  currency: PropTypes.string,
  isNarrowScreen: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default BenefitCheckoutItems;



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/BenefitCheckoutItems.js